import { useNavigate } from 'react-router-dom';
import { CheckCircle, Users, Lock, Shield, FileCheck, Fingerprint, Building, Eye } from 'lucide-react';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page" data-testid="landing-page">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="hero-content">
          <div className="hero-logo">
            <img src="/hakicheck-logo.png" alt="HakiCheck" className="logo-image" />
          </div>
          <p className="hero-subtitle">
            Trusted background checking platform for employers, corporate entities, 
            and security services across Africa. Fast, reliable, and secure verification services.
          </p>
          <button 
            className="hero-cta"
            data-testid="get-started-btn"
            onClick={() => navigate('/auth')}
          >
            <span>Get Started Today</span>
            <CheckCircle size={24} />
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title">Comprehensive Verification Services</h2>
        <p className="section-subtitle">
          From identity to criminal records, we provide thorough background checks 
          tailored for the African market
        </p>

        <div className="features-grid">
          <div className="feature-card" data-testid="feature-identity">
            <div className="feature-icon">
              <CheckCircle size={28} />
            </div>
            <h3 className="feature-title">Identity Verification</h3>
            <p className="feature-description">
              Cross-check with national ID databases, international passports, 
              and voter registration systems to verify identities.
            </p>
          </div>

          <div className="feature-card" data-testid="feature-criminal">
            <div className="feature-icon">
              <Lock size={28} />
            </div>
            <h3 className="feature-title">Criminal Background Checks</h3>
            <p className="feature-description">
              Access police records, court databases, and security watchlists 
              to identify potential risks.
            </p>
          </div>

          <div className="feature-card" data-testid="feature-biometrics">
            <div className="feature-icon">
              <Fingerprint size={28} />
            </div>
            <h3 className="feature-title">Biometrics & Biodata Verification</h3>
            <p className="feature-description">
              Advanced facial recognition, fingerprint matching, and comprehensive biodata validation 
              with liveness detection to prevent fraud and identity theft.
            </p>
          </div>

          <div className="feature-card" data-testid="feature-documents">
            <div className="feature-icon">
              <FileCheck size={28} />
            </div>
            <h3 className="feature-title">Document Verification</h3>
            <p className="feature-description">
              Authenticate passports, driver's licenses, certificates, and other official documents 
              using AI-powered forgery detection and hologram validation.
            </p>
          </div>

          <div className="feature-card" data-testid="feature-aml">
            <div className="feature-icon">
              <Shield size={28} />
            </div>
            <h3 className="feature-title">AML Compliance</h3>
            <p className="feature-description">
              Anti-Money Laundering screening against global sanctions lists, PEP databases, 
              and adverse media to ensure regulatory compliance.
            </p>
          </div>

          <div className="feature-card" data-testid="feature-assets">
            <div className="feature-icon">
              <Building size={28} />
            </div>
            <h3 className="feature-title">Asset Verification</h3>
            <p className="feature-description">
              Physical verification of vehicles, property, equipment, and other valuable assets 
              with GPS tracking, photo evidence, and ownership confirmation.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="features-section" style={{background: 'linear-gradient(135deg, #2d6a4f 0%, #1b4332 100%)', color: 'white'}}>
        <h2 className="section-title" style={{color: 'white'}}>Ready to Get Started?</h2>
        <p className="section-subtitle" style={{color: 'rgba(255,255,255,0.9)'}}>
          Join thousands of organizations using HakiCheck for reliable background verification
        </p>
        <div style={{textAlign: 'center', marginTop: '2rem'}}>
          <button 
            className="hero-cta"
            data-testid="cta-signup-btn"
            onClick={() => navigate('/auth')}
          >
            <span>Create Your Account</span>
            <CheckCircle size={24} />
          </button>
        </div>
      </section>

      <style>{`
        .hero-logo {
          margin-bottom: 2rem;
          display: flex;
          justify-content: center;
        }

        .logo-image {
          height: 120px;
          width: auto;
        }

        @media (max-width: 768px) {
          .logo-image {
            height: 80px;
          }
        }
      `}</style>
    </div>
  );
}

export default LandingPage;
